const droneServices = [
    { id: 22, name: 'Drone Photography' },
    { id: 25, name: 'Drone Photography Budget' },
    { id: 26, name: 'Drone Companion Photography' },
    { id: 51, name: 'Companion Drone Photography' },
  ]
  
  export default droneServices
  